/**
 * Created by - Ashlekh on 04-02-2025
 * Reason - Created Country card to show details of the country
 */
import countryCardStyle from "./CountryCard.module.css";
const CountryCard = ({ country }) => {
  return (
    <div className={countryCardStyle.card}>
      <div
        className={`${countryCardStyle.label} ${countryCardStyle.modalCountryName}`}
      >
        {country.country_name}
      </div>
      {country.calling_code && country.calling_number && (
        <div className={`${countryCardStyle.column}`}>
          <div className={` ${countryCardStyle.column}`}>
            <div className={`${countryCardStyle.label}`}>Contact Number</div>

            <div style={{ width: "10px", fontWeight: "bold" }}>: </div>
          </div>

          <div>
            {country?.calling_code} {country.calling_number}
          </div>
        </div>
      )}
      {country.email && (
        <div className={`${countryCardStyle.column}`}>
          <div className={` ${countryCardStyle.column}`}>
            <div className={`${countryCardStyle.label}`}> Email </div>
            <div style={{ width: "10px", fontWeight: "bold" }}>: </div>
          </div>{" "}
          <div>{country.email}</div>
        </div>
      )}
      {country.address && (
        <div className={`${countryCardStyle.column}`}>
          <div className={` ${countryCardStyle.column}`}>
            <div className={`${countryCardStyle.label}`}>Address </div>
            <div style={{ width: "10px", fontWeight: "bold" }}>: </div>
          </div>

          <div
            style={{
              wordWrap: "break-word",
            }}
          >
            {country.address}
          </div>
        </div>
      )}

      {country.google_map_link?.length > 0 ? (
        <div>
          <iframe
            src={country.google_map_link}
            className={countryCardStyle.map}
          />
        </div>
      ) : null}
    </div>
  );
};

export default CountryCard;
